import Container from '@components/container';
import { ContainerSize, PageTitle } from '@lib/types';

export default function PageTitleSection({
  data: { title },
}: {
  data: PageTitle;
}) {
  return (
    <Container size={ContainerSize.wide}>
      <div className="grid grid-cols-12 gap-1.5 md:gap-6">
        <h1 className="text-32 md:text-35 leading-130 font-bold text-blue-800 col-start-2 col-span-11 lg:col-start-4 lg:col-span-6">
          {title}
        </h1>
      </div>
    </Container>
  );
}
